export const createPointClickHandler = (pointCountRef, dispatch) => {
    return function(e) {
        try {
            const chart = e.point.series.chart;
            const series = chart.get('performance-line');

            if (!series) return;

            const y = e.point.y;
            const x = e.point.x;

            if (pointCountRef.current === 2) {
                // Third click — reset
                while (series.points.length > 0) {
                    series.removePoint(0);
                }
                dispatch({ type: 'RESET' });
            } else if (pointCountRef.current === 1) {
                // Second click — calculate returns
                series.addPoint([x, y]);

                let changeAnn = 0;
                if (series.points && series.points.length >= 2) {
                    const point1 = series.points[0].x != null && series.points[0].y != null
                        ? series.points[0]
                        : series.points[1];

                    const [early, late] = point1.x <= x
                        ? [point1, { x, y }]
                        : [{ x, y }, point1];

                    const timeDiff = (late.x - early.x) / (365 * 24 * 60 * 60 * 1000);

                    if (timeDiff !== 0 && early.y !== 0) {
                        const ann = (Math.pow(late.y / early.y, 1 / timeDiff) - 1) * 100;
                        changeAnn = isFinite(ann) ? ann : 0;
                    }
                }

                dispatch({ type: 'SECOND_CLICK', y, changeAnn });
            } else {
                // First click — record starting point
                series.addPoint([x, y]);
                dispatch({ type: 'FIRST_CLICK', y });
            }
        } catch (error) {
            console.error('Error in click handler:', error);
        }
    };
};
